import Image from 'next/image';
import cn from 'classnames';
import styled from 'styled-components';

import { BFC } from '@/shared/types';

import SvgSpinner from './spinner.svg';

type SpinnerSize = 'sm' | 'md';

type SpinnerProps = {
  size?: SpinnerSize;
};

export const Spinner: BFC<SpinnerProps> = ({ style, size, className }) => {
  return (
    <Container className={cn(className, size)} style={style}>
      <Image className="spinner" src={SvgSpinner} width={20} height={20} alt="spinenr" />
    </Container>
  );
};

const Container = styled.div`
  width: 20px;
  height: 20px;
  animation: spin 1000ms steps(8) infinite;

  &.md {
    width: 40px;
    height: 40px;
  }

  .spinner {
    width: 100%;
    height: 100%;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
